<template>
  <Layout>
    <div class="row" v-if="userData.permissions['view_dashboard']==1">
    <div class="row mt-md-n3">
      <div class="col-xl-12" >
        <div class="row mb-3">
          <div class="col-md-3 mt-4 h4" style="font-family:Arial"><i class="mdi mdi-calendar"></i> {{activeterm}}</div>
          <div class="col-md-9">
            <div class="row justify-content-end">
            <b-form-group class="col-md-3" label="Term">
              <v-select :options="schoolterms" placeholder="Select Term" v-model="schoolterm" label="name"></v-select>
            </b-form-group>          
            <div class="col-md-3">
              <label>Year</label>
              <v-select :options="years" placeholder="Select Year" v-model="year"></v-select>
            </div>
            <div class="col-md-2 mt-md-4 mt-2 p-lg-0">
             <b-button variant="primary" class="w-100" @click="FilterData()"><i class="mdi mdi-account-search"></i> Filter</b-button>
            </div>
          </div>
          </div>
        </div>
        <div class="row">
          <div class="col-sm-2">
            <div class="card p-2 shadow-lg">
            <div class="card-body p-2">
              <!-- <div class="media"> -->
                <div class="media-body"><small class="text-muted fw-medium mb-2">Total Students</small><h5 class="mb-0">{{commas(students)}}</h5></div>
                <!-- <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-account-multiple font-size-16"></i></span>
                </div> -->
              <!-- </div> -->
              <b-progress :max="students" variant="danger" height="1rem" class="mt-2" :style="{ 'background-color': '#A9A9A9' }">
                <b-progress-bar :value="newstudents">
                  <span>New : {{ newstudents }}</span>
                </b-progress-bar>
              </b-progress>
            </div>
          </div>
          </div>
          <div class="col-sm-2">
            <div class="card p-2 shadow-lg">
            <div class="card-body p-2">
              <!-- <div class="media"> -->
                <div class="media-body"><small class="text-muted fw-medium mb-2">Male Students</small><h5 class="mb-0">{{commas(malestudents)}} </h5></div>
                <!-- <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-human-male font-size-16"></i></span>
                </div> -->
              <!-- </div> -->
              <b-progress :max="malestudents" variant="danger" height="1rem" class="mt-2" :style="{ 'background-color': '#A9A9A9' }">
                <b-progress-bar :value="boardingmalestudents">
                  <span>Boarding : {{ boardingmalestudents }}</span>
                </b-progress-bar>
              </b-progress>
            </div>
          </div>
          </div>
          <div class="col-sm-2">
            <div class="card p-2 shadow-lg">
            <div class="card-body p-2">
              <!-- <div class="media"> -->
                <div class="media-body"><small class="text-muted fw-medium mb-2">Female Students</small><h5 class="mb-0">{{commas(femalestudents)}} </h5></div>
                <!-- <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-human-female font-size-16"></i></span>
                </div> -->
              <!-- </div> -->
              <b-progress :max="femalestudents" variant="danger" height="1rem" class="mt-2" :style="{ 'background-color': '#A9A9A9' }">
                <b-progress-bar :value="boardingfemalestudents">
                  <span>Boarding : {{ boardingfemalestudents }}</span>
                </b-progress-bar>
              </b-progress>
            </div>
          </div>
          </div>
          <div class="col-sm-2">
            <div class="card p-2 shadow-lg">
            <div class="card-body p-2">
              <!-- <div class="media"> -->
                <div class="media-body"><small class="text-muted fw-medium mb-2">Fees Projections</small><h5 class="mb-0">{{commas(totalprojections)}} </h5></div>
                <!-- <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-database font-size-16"></i></span>
                </div> -->
              <!-- </div> -->
              <b-progress :max="totalprojections" variant="danger" height="1rem" class="mt-2" :style="{ 'background-color': '#A9A9A9' }">
                <b-progress-bar :value="totalfees">
                  <span>Fees : {{totalfees}}</span>
                </b-progress-bar>
              </b-progress>
            </div>
          </div>
          </div>
          <div class="col-sm-2">
            <div class="card p-2 shadow-lg">
            <div class="card-body p-2">
              <!-- <div class="media"> -->
                <div class="media-body"><small class="text-muted fw-medium mb-2">Fees Collections</small><h5 class="mb-0">{{commas(totalpayments)}} </h5></div>
                <!-- <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-database font-size-16"></i></span>
                </div> -->
              <!-- </div> -->
              <b-progress :max="totalpayments" variant="danger" height="1rem" class="mt-2" :style="{ 'background-color': '#A9A9A9' }">
                <b-progress-bar :value="feespayments">
                  <span>Fees : {{ feespayments }}</span>
                </b-progress-bar>
              </b-progress>
            </div>
          </div>
          </div>
          <div class="col-sm-2">
            <div class="card p-2 shadow-lg">
            <div class="card-body p-2">
              <!-- <div class="media"> -->
                <div class="media-body"><small class="text-muted fw-medium mb-2">Fees Balance</small><h5 class="mb-0">{{commas(totalprojections-totalpayments)}} </h5></div>
                <!-- <div class="avatar-sm align-self-center mini-stat-icon rounded-circle bg-primary">
                  <span class="avatar-title"><i class="mdi mdi-database font-size-16"></i></span>
                </div> -->
              <!-- </div> -->
              <b-progress :max="(totalprojections-totalpayments)" variant="danger" height="1rem" class="mt-2" :style="{ 'background-color': '#A9A9A9' }">
                <b-progress-bar :value="balances">
                  <span>Fees: {{ balances }}</span>
                </b-progress-bar>
              </b-progress>
            </div>
          </div>
          </div>
          <!-- <div class="col-sm-2">
            <div class="card p-2 shadow-lg">
            <div class="card-body p-2">
              
                <div class="media-body"><small class="text-muted fw-medium mb-2">Expenses</small><h5 class="mb-0">{{commas(totalexpenses)}} </h5></div>
                
              <b-progress :max="totalpayments" variant="danger" height="1rem" class="mt-2" :style="{ 'background-color': '#A9A9A9' }">
                <b-progress-bar :value="totalexpenses">
                  <span>Expenses : {{ totalexpenses }}</span>
                </b-progress-bar>
              </b-progress>
            </div>
          </div>
          </div> -->
          
        </div>
        <div class="row">
          <div class="col-sm-5">
            <div class="card p-1">
              <div class="card-body shadow-lg p-1">
                <div class="h5 text-center">Enrollment Analysis</div>
                  <apexchart class="apex-charts" type="bar" height="250px" :options="this.enrollmentsanalysis.chartOptions"  :series="enrollmentsanalysis.series"></apexchart>
              </div>
            </div>
          </div>
          <div class="col-sm-7">
            <div class="card p-1">
              <div class="card-body shadow-lg p-1">
                <div class="h5 text-center">Fees Collection Per Class</div>
                    <apexchart class="apex-charts" type="line" height="250" :options="monthlysales.chartOptions"  :series="monthlysales.series"></apexchart>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>    
  <div v-else>
    <div class="row justify-content-center">
      <div class="col-md-8 col-xl-6">
        <div>
          <center><span class="text-primary h4">You have no permission to view the Dashboard.</span></center>
          <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
        </div>
      </div>
    </div>
  </div> 
  </Layout>
</template>

<script>
import appConfig from "@/app.config";
import { schooltermComputed, schooltermMethods } from "@/state/helpers";
import axios from "axios";
import Layout from "../../layouts/main";

export default {
  page: {
    title: "Dashboard",
    meta: [{name: "description",content: appConfig.description}],
  },
  components: {  Layout, },
  data() {
    return {
    options : { weekday: "long", year: "numeric", month: "long", day: "numeric",},
    userData: JSON.parse(localStorage.getItem("user")),
    activeterm: localStorage.getItem("schoolterm"),
    date_from:new Date().toLocaleDateString('fr-CA'),
    date_to:new Date().toLocaleDateString('fr-CA'),
    schoolterm:"",
    year:new Date().getFullYear(),

    students:0, newstudents:0,
    malestudents:0, boardingmalestudents:0,
    femalestudents:0, boardingfemalestudents:0,
    expenses:'0',
    productsanalysis:[],
    schoolfees:'0',
    otherfees:'0',
    balances:'0',
    totalfees:'0',
    monthlysales:{
      series: [{ name: "Sales", data: [],},],
      chartOptions: { noData: {text: 'Please Wait...'}, 
      colors: ['#ef2c01','#080008'],
      legend: { show:false},
      dataLabels: { enabled: false },},
    },
    enrollmentsanalysis:{
      series: [{ name: "Products", data: [],},],
      chartOptions: { noData: {text: 'Please Wait...'}, 
      fill: { colors: ['#ef2c01','#080008']},
      legend: { show:false},
      dataLabels: { enabled: false }, yaxis: {
      labels: { formatter: (value) => { return value.toFixed(0) },
      }
    },},
    },
    feespayments:0,
    totalpayments:0,
    totalprojections:0,
    totalbalances:0,
    };
  },
  mounted() {
    this.todaysanalysis();
    this.fetchSchoolTerms();
    this.schoolterm = this.schoolterms.find(option => option.active == 1);
  },
  computed: {
    ...schooltermComputed,
    years() {
      const currentYear = new Date().getFullYear();
      const startYear = currentYear - 10;
      const endYear = currentYear;
      const yearArray = [];
      for (let year = startYear; year <= endYear; year++) {  yearArray.push(year);  }
      return yearArray;
    },
  },
  methods: {
    ...schooltermMethods,
    commas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        },
    async todaysanalysis(){
      let url = `/todaysanalysis`;
      await axios.get(url).then((response) => {
        this.students = response.data.students;
        this.newstudents = response.data.newstudents;
        this.malestudents = response.data.malestudents;
        this.boardingmalestudents = response.data.boardingmalestudents;
        this.boardingfemalestudents = response.data.boardingfemalestudents;
        this.femalestudents = response.data.femalestudents;
        this.purchases = response.data.purchases;
        this.feespayments= response.data.feespayments;
        this.totalpayments= response.data.totalpayments;
        this.balances = response.data.balances;
        this.totalexpenses =response.data.totalexpenses;
        this.totalfees = response.data.totalfees;
        this.totalprojections = response.data.totalprojections;
        this.totalbalances = response.data.totalbalances;
        this.schoolfees=response.data.schoolfees;
        this.otherfees=response.data.otherfees;
        this.productsanalysis=response.data.enrollments;
      });
      let SalesData = this.schoolfees.map((e) => { return { x: e.month, y: e.amount, }; });
      let PaymentsData = this.otherfees.map((e) => { return { x: e.month, y: e.amount, }; });
      let enrollmentsData = this.productsanalysis.map((e) => { return { x: e.name, y: e.registrations, }; });
      this.monthlysales.series = [{ name: "School Fees", data: SalesData },{ name: "Other Fees", data: PaymentsData }];
      this.enrollmentsanalysis.series = [{ name: "Students", data: enrollmentsData }];
    },
    async FilterData(){
      let formData = new FormData();
      formData.append("schoolterm", this.schoolterm.id);
      formData.append("year", this.year);
      let url = `/filteredanalysis`;
      await axios.post(url, formData).then((response) => {
        this.students = response.data.students;
        this.newstudents = response.data.newstudents;
        this.malestudents = response.data.malestudents;
        this.boardingmalestudents = response.data.boardingmalestudents;
        this.boardingfemalestudents = response.data.boardingfemalestudents;
        this.femalestudents = response.data.femalestudents;
              
        this.activeterm = this.schoolterm.name+" - "+this.year;
        this.feespayments= response.data.feespayments;
        this.totalpayments= response.data.totalpayments;
        this.balances = response.data.balances;

        this.schoolfees=response.data.schoolfees;
        this.otherfees=response.data.otherfees;
        this.productsanalysis=response.data.enrollments;
      });
      let SalesData = this.schoolfees.map((e) => { return { x: e.month, y: e.amount, }; });
      let PaymentsData = this.otherfees.map((e) => { return { x: e.month, y: e.amount, }; });
      let enrollmentsData = this.productsanalysis.map((e) => { return { x: e.name, y: e.registrations, }; });
      let attendanceData = this.productsanalysis.map((e) => { return { x: e.name, y: e.attendance, }; });
      this.monthlysales.series = [{ name: "School Fees", data: SalesData },{ name: "Other Fees", data: PaymentsData }];
      this.enrollmentsanalysis.series = [{ name: "Students", data: enrollmentsData }];
      this.attendancesanalysis.series = [{ name: "Students", data: attendanceData }];
    },
  },
};
</script>